// src/utils/transcriptUtils.js

/**
 * Extract YouTube video ID from a YouTube URL
 * @param {string} url - YouTube URL
 * @returns {string|null} - Video ID or null if invalid
 */
export const extractVideoId = (url) => {
  const regex = /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

/**
 * Fetch transcript for a YouTube video
 * @param {string} videoId - YouTube video ID
 * @returns {Promise<Array>} - Array of transcript segments
 */
export const fetchTranscript = async (videoId) => {
  try {
    // Use the deployed Firebase Function URL
    const baseUrl = 'https://us-central1-profstudymate.cloudfunctions.net/pdfExtractor';
    
    const response = await fetch(`${baseUrl}/transcript/${videoId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch transcript');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching transcript:', error);
    throw error;
  }
};

/**
 * Get transcript text as a single string
 * @param {Array} transcript - Transcript segments from YouTube
 * @returns {string} - Combined transcript text
 */
export const getTranscriptText = (transcript) => {
  if (!transcript || !Array.isArray(transcript)) {
    return '';
  }
  return transcript.map(segment => segment.text).join(' ');
};

/**
 * Get transcript with timestamps
 * @param {Array} transcript - Transcript segments from YouTube
 * @returns {Array} - Array of objects with text and timestamp
 */
export const getTranscriptWithTimestamps = (transcript) => {
  if (!transcript || !Array.isArray(transcript)) {
    return [];
  }
  return transcript.map(segment => ({
    text: segment.text,
    timestamp: segment.offset / 1000, // Convert to seconds
    duration: segment.duration / 1000 // Convert to seconds
  }));
};
